"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PACE_VIDEO_LIBRARY = exports.PACE_KNOWLEDGE_LIBRARY = exports.OSCE_KNOWLEDGE_VIDEO_LIBRARY = exports.PUBLIC_QBANK_KNOWLEDGE_LIBRARY = exports.QBANK_KNOWLEDGE_VIDEO_LIBRARY = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
const osce_1 = require("./../../fragments/osce");
exports.QBANK_KNOWLEDGE_VIDEO_LIBRARY = (0, client_1.gql) `
  ${fragments_1.CHAPTER_FIELDS}
  query QBankKnowledgeVideoLibrary($typeId: [Int], $videosOnly: Boolean) {
    restricted {
      quesBook(typeId: $typeId, videosOnly: $videosOnly) {
        id
        name
        typeId
        demo
        entitlement {
          id
          name
          index
        }
        unreadConcepts
        completedConcepts
        revisingConcepts
        urgentConcepts
        unwatchedVideos
        completedVideos
        revisingVideos
        urgentVideos
        concepts {
          id
          name
          demo
          status
          totalCards
          totalQuestions
          chapter {
            ...ChapterFields
          }
          userNote {
            id
            userId
            conceptId
            note
            updatedAt
          }
          userChapter {
            id
            userId
            conceptId
            explanation
            updatedAt
          }
          topicId
          videos {
            id
            demo
            status
            title
            museId
            thumbnail
            concepts {
              id
              name
            }
            live
            description
            duration
          }
        }
      }
    }
  }
`;
exports.PUBLIC_QBANK_KNOWLEDGE_LIBRARY = (0, client_1.gql) `
  ${fragments_1.CHAPTER_FIELDS}
  query PublicQuesBook($typeId: [Int], $videosOnly: Boolean) {
    quesBook(typeId: $typeId, videosOnly: $videosOnly) {
      id
      name
      typeId
      demo
      entitlement {
        id
        name
        index
      }
      unreadConcepts
      completedConcepts
      revisingConcepts
      urgentConcepts
      unwatchedVideos
      completedVideos
      revisingVideos
      urgentVideos
      concepts {
        id
        name
        demo
        status
        totalCards
        totalQuestions
        chapter {
          ...ChapterFields
        }
        topicId
        userNote {
          id
          userId
          conceptId
          note
          updatedAt
        }
        userChapter {
          id
          userId
          conceptId
          explanation
          updatedAt
        }
        videos {
          id
          demo
          status
          title
          museId
          thumbnail
          concepts {
            id
            name
          }
          live
          description
          duration
        }
      }
    }
  }
`;
exports.OSCE_KNOWLEDGE_VIDEO_LIBRARY = (0, client_1.gql) `
  ${osce_1.OSCE_STATION_FIELDS}
  query OsceKnowledgeVideoLibrary($videosOnly: Boolean) {
    restricted {
      osceBook(videosOnly: $videosOnly) {
        ...OsceStationFields
        lastOsceMarksheetId
        score
      }
    }
  }
`;
exports.PACE_KNOWLEDGE_LIBRARY = (0, client_1.gql) `
  ${fragments_1.CHAPTER_FIELDS}
  query PaceKnowledgeLibrary {
    restricted {
      paceBook {
        id
        name
        demo
        status
        typeId
        userNote {
          id
          userId
          conceptId
          note
          updatedAt
        }
        userChapter {
          id
          userId
          conceptId
          explanation
          updatedAt
        }
        entitlement {
          id
          name
          index
        }
        chapter {
          ...ChapterFields
        }
        topicId
        videos {
          id
          demo
          status
          title
          museId
          thumbnail
          concepts {
            id
            name
          }
          live
          description
          duration
        }
      }
    }
  }
`;
exports.PACE_VIDEO_LIBRARY = (0, client_1.gql) `
  ${osce_1.OSCE_STATION_FIELDS}
  query PaceVideoLibrary($videosOnly: Boolean) {
    restricted {
      osceBook(videosOnly: $videosOnly) {
        ...OsceStationFields
        lastOsceMarksheetId
        score
      }
    }
  }
`;
